module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Ni har kandidater att hantera":"You have candidates to handle"},"sv":{"Ni har kandidater att hantera":"Ni har kandidater att hantera"}}')
  delete Component.options._Ctor
}
